import { IStaggeredListItem } from "../pages/dashboard/homePage/StaggeredList";

export enum ToolType {
    //Note: maintain this order as toolType logic is based on numbers
    backgroundRemoval = "backgroundRemoval",
    backgroundColor = "backgroundColor",
    imageResizer = "imageResizer",
    listingGenerator = "listingGenerator",
}


export const list: IStaggeredListItem[] = [{
    title: "Background Removal",
    image: "/images/home/bgRemoval.jpg",
    extraData: {
        type: ToolType.backgroundRemoval
    }
},{
    title: "Background Color",
    image: "/images/home/BGColor.jpg",
    extraData: {
        type: ToolType.backgroundColor
    }
},{
    title: "Image Resizer",
    image: "/images/home/ImageResizer.png",
    extraData: {
        type: ToolType.imageResizer
    }
},
{
    title: "Listing Generator",
    image: "/images/home/listingGenerator.png",
    extraData: {
        type: ToolType.listingGenerator
    }
},
]

export const BULK_AI_TYPE = {
    BULK_UPLOAD_GENAI:"BULK_UPLOAD_GENAI",
    BULK_UPLOAD_FACE_SWAP:"BULK_UPLOAD_FACE_SWAP",
    BULK_UPLOAD_MODEL_GEN:"BULK_UPLOAD_MODEL_GEN"
};

export const defaultDMSCanvasFile = {
    layers: [{
        id: "Image 1",
        type: "image",
        aspectRatioLock: false,
        brightness: 0,
        contrast: 0,
        dimensions: {
            height:500,
            width:500
        },
        position: {
            x:0,
            y:0
        },
        opacity:1,
        src:"",
        saturation:0,
        hue: 0,
        hueShift: Array(8).fill({
            hueShift: 0,
            brightnessShift: 0,
            saturationShift: 0,
        }),
        rotation: 0,
        flipX: false,
        flipY: false,
        tags: ["product-image"],
        shadow: undefined,
    }],
    size: {
        height: 1500,
        width: 1500
    },
    backgroundInfo: {
        src: "",
        color: "#FFFFFF",
        scaleX: 1,
        scaleY: 1,
    }
}

export const defaultDMSCanvasBGFile = {
    layers: [],
    size: {
        height: 2560,
        width: 1440
    },
    backgroundInfo: {
        src: "",
        color: "#FFFFFF",
        scaleX: 1,
        scaleY: 1,
    }
}

export const FACE_SWAP_AND_MODEL_PAYLOAD = {
    imageId: "",
    faceMask: "",
    updateData: {
        pyraCanny: {
            stopAt: "0.95",
            weightage: 1,
            imageUrl: ""
        },
        imagePrompt: {
            stopAt: "0.95",
            weightage: 1,
            imageUrl: ""
        },
        faceSwap: {
            stopAt: "0.95",
            weightage: 1,
            imageUrl: "",
            docId: ""
        },
        referenceImage:{
            "imageUrl": "",
            "docId": "",
            "weightage": 0.9,
            "stopAt": 0.9,
            "event": ""
        }
    },
    colorAdjustment:{
        brightness:0,
        warmth:0,
    }
};

const titleToToolType: Record<string, ToolType> = {
    "background removal": ToolType.backgroundRemoval,
    "background color": ToolType.backgroundColor,
    "listing generator": ToolType.listingGenerator,
    "image resizer": ToolType.imageResizer,
};

export const getToolTypeFromTitle = (title: string): ToolType | undefined => {
    const normalizedTitle = title?.trim()?.toLowerCase(); 
    return titleToToolType[normalizedTitle] ?? undefined;
};

const toolTypeToTitle: Record<ToolType, string> = {
    [ToolType.backgroundRemoval]: "Background Removal",
    [ToolType.backgroundColor]: "Background Color",
    [ToolType.listingGenerator]: "Listing Generator",
    [ToolType.imageResizer]: "Image Resizer",
};

const toolTypeToToaster: Record<ToolType, string> = {
    [ToolType.backgroundRemoval]: "Background Removed Images",
    [ToolType.backgroundColor]: "Your Colored Background Images",
    [ToolType.listingGenerator]: "Listing Generator",
    [ToolType.imageResizer]: "Your Resized Images",
}

export const getTitleFromToolType = (toolType: ToolType): string | undefined => {
    return toolTypeToTitle[toolType] ?? undefined;
};

export const getToasterMessageFromToolType = (toolType: ToolType): string | undefined => {
    return toolTypeToToaster[toolType] ?? undefined;
};